import io from "socket.io-client";
import { fetchBaseUrl } from "core/utils/common";

export type ChatSocket = ReturnType<typeof io>;

export const createChatSocket = (): ChatSocket => {
  const baseURL = fetchBaseUrl({ port: 8080 });

  return io(baseURL, {
    transports: ["websocket"],
    secure: true,
    timeout: 300000,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    upgrade: false,
    forceNew: false,
  });
};
